module.exports = __webpack_public_path__ + "static/TT2-evergreen-page-screening-sales-tips-iStock-1313903358.58437d6b.jpg";